import React from 'react';
import { Link } from 'react-router-dom';
import packageJson from '../../package.json';
import { PRIMARY_NAV, SECONDARY_NAV } from './Layout/nav';

const Footer = () => {
   const year = new Date().getFullYear();
   return (
      <footer className="relative z-10 mt-32 border-t border-white/[0.06]">
         <div className="page py-16">
            <p className="max-w-3xl font-display text-4xl leading-tight text-bone md:text-6xl">
               History is written by those who <em className="text-signal">remember</em>.
            </p>

            <div className="mt-16 grid grid-cols-2 gap-10 md:grid-cols-4">
               <div className="col-span-2">
                  <p className="eyebrow mb-4">Red Sentinel</p>
                  <p className="max-w-sm text-sm leading-relaxed text-bone-muted">
                     An open archive of corporate, political and societal misconduct, so that it is not forgotten.
                  </p>
               </div>
               <div>
                  <p className="eyebrow mb-4">Sections</p>
                  <ul className="space-y-2 text-sm">
                     {PRIMARY_NAV.map(item => (
                        <li key={item.path}>
                           <Link to={item.path} className="underline-grow text-bone-muted hover:text-bone">
                              {item.title}
                           </Link>
                        </li>
                     ))}
                  </ul>
               </div>
               <div>
                  <p className="eyebrow mb-4">Project</p>
                  <ul className="space-y-2 text-sm">
                     {SECONDARY_NAV.map(item => (
                        <li key={item.path}>
                           <Link to={item.path} className="underline-grow text-bone-muted hover:text-bone">
                              {item.title}
                           </Link>
                        </li>
                     ))}
                  </ul>
               </div>
            </div>

            <div className="mt-16 flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.2em] text-bone-dim">
               <span>&copy; Red Sentinel {year}</span>
               <span>v{packageJson.version}</span>
            </div>
         </div>
      </footer>
   );
};

export default Footer;
